import {useAppContext} from '../../components/app/AppContext';
import {httpService} from '../../core/services/http.service';

export interface IKeyValueStorageItem {
    accountId: number;
    key: string;
    value: string;
}

export interface IKeyValueStorageServiceResponse {
    data: {rows: IKeyValueStorageItem[]; success: boolean};
}

export class KeyValueStorageService {
    constructor() {}

    getBooleanValue(key: string, defaultValue: boolean = false, pathKey: boolean = false): Promise<boolean> {
        return this.getKey(key, pathKey).then((response: any): boolean => {
            const data: {
                accountId: number;
                value: string;
                key: string;
            } = response.data.rows[response.data.rows.length - 1];
            if (data && data.value.length) {
                return data.value == 'true';
            }
            return defaultValue;
        });
    }

    getKey(key: string, pathKey: boolean = true): Promise<IKeyValueStorageServiceResponse> {
        key = pathKey ? this._patchKey(key) : key;
        return httpService.get(`/gt/gt-api/keyValueStorage/get/${key}`).then((response: any) => response);
    }

    saveKey(key: string, data: any, pathKey: boolean = true): Promise<any> {
        key = pathKey ? this._patchKey(key) : key;
        return httpService.post('/gt/gt-api/keyValueStorage/put/', {
            key,
            value: JSON.stringify(data)
        });
    }

    private _patchKey(key: string): string {
        const userId: number = useAppContext().user.id;
        return `${key}_${userId}`;
    }
}
